import { AdminResponsibility } from './administrator'
import { EducatorTeachedSubjects, EducatorTeachedGrades } from './educator'
import { OtherMoteUse, OtherRoleDescription } from './other'
import { StudentAge, StudentMinorPermission } from './student'
import { HearAbout, MoteUse, Roles, School } from './shared'

const STUDENT_STEPS = [StudentAge, StudentMinorPermission]
const EDUCATOR_STEPS = [
  EducatorTeachedSubjects,
  EducatorTeachedGrades,
  MoteUse,
  HearAbout,
  School
]
const ADMIN_STEPS = [AdminResponsibility, HearAbout, MoteUse, School]
const OTHER_STEPS = [OtherMoteUse, OtherRoleDescription, School]

export function getSteps(role) {
  const steps = [Roles]

  switch (role) {
    case 'student': {
      steps.push(...STUDENT_STEPS)
      break
    }
    case 'educator': {
      steps.push(...EDUCATOR_STEPS)
      break
    }
    case 'administrator': {
      steps.push(...ADMIN_STEPS)
      break
    }
    case 'other': {
      steps.push(...OTHER_STEPS)
      break
    }
    default:
  }

  return steps
}
